import {useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom'

import DataImportFormTabs from '../../../components/3modules/DataImportFormTabs'
import ServiceImportTemplate from '../../../components/5templates/ServiceImportTemplate'
import {
    getItemFromSessionStorage, removeAllItemsInSessionStorage, setItemToSessionStorage
} from '../../../services/util/sessionStorageManager'
import {
    contactListFormatter,
    formatNewServiceSet, areAllObjectValuesEmpty, serviceSetFormatter
} from '../../../services/util/miscellaneousService'
import ApiService from '../../../common/ApiCalls'
import {FeedbackSnackbar} from '../../../components/1elements'
import {validateApproverName} from '../../../services/util/editChecks'
import LoaderBackdrop from '../../../components/2compounds/LoaderBackdrop'

const ImportServiceForm = () => {
    const navigate = useNavigate()
    const [serviceList, setServiceList] = useState({})
    const [selectedServiceType, setSelectedServiceType] = useState('')
    const [options, setOptions] = useState([])
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false)
    const [, setSearchKeyword] = useState('')
    const [selectedServiceTypeId, setSelectedServiceTypeId] = useState('')
    const [snackbar, setSnackbar] = useState({isOpen: false, severity: "", message: "Information is successfully saved!"})
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [approver, setApprover] = useState(null)
    const [showError, setShowError] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [loaded, setLoaded] = useState(false)

    const onSave = async () => {
        const newLocation = getItemFromSessionStorage('newLocation')
        const newClientProfile = getItemFromSessionStorage('newClientProfile')
        const {existingContacts, newContacts} = contactListFormatter(getItemFromSessionStorage('newContact'))
        const selectedServiceList = getItemFromSessionStorage('selectedServiceList')
        const newServiceSet = getItemFromSessionStorage('newServiceSet')
        const initiatorId = localStorage.getItem('userId')
        const initiatorEmail = localStorage.getItem('email')
        const pendingDataId = getItemFromSessionStorage('pendingDataId')

        if(!validateApproverName(approver)){
            setIsModalOpen(false)
            setIsLoading(true)
            const data = {
                pendingDataId: pendingDataId ? pendingDataId : '',
                initiatorId,
                initiatorEmail,
                approverId: approver['user_id'],
                existingContacts,
                newContacts,
                account: newClientProfile,
                newLocation,
                newServiceSet: serviceSetFormatter(formatNewServiceSet(newServiceSet, selectedServiceList)),
            }

            ApiService().addNewLocationToNewClient(data)
                .then((res)=>{
                    if(res.error){
                        setSnackbar({severity: 'fail', isOpen: true,
                            message: 'We could not find the address on the map. Please input correct address'})
                    }else{
                        const data = {email: approver.email, name: approver.username}
                        ApiService().notifyApprover(data)
                            .then(()=>{
                                setLoaded(true)
                                setSnackbar({message: "Information is successfully saved!", severity: 'success', isOpen: true})
                                window.setTimeout(()=>{
                                    onCancel()
                                }, 2000)
                            })
                            .catch((err)=>{
                                console.log(err)
                            })
                    }
                })
                .catch((err)=>{
                    console.log(err)
                    setSnackbar( {message: "There was an error!", severity: 'fail', isOpen: true})
                })
        }else{
            setShowError(true)
        }
    }

    const onCancel = () => {
        removeAllItemsInSessionStorage()
        navigate('/adminDashboard')
    }
    const onNext = () => {
        setItemToSessionStorage('selectedServiceList', serviceList)
        if(!areAllObjectValuesEmpty(serviceList)){
            setIsModalOpen(true)
        }else{
            setIsSnackbarOpen(true)
        }
    }
    const onPrev = () => {
        setItemToSessionStorage('selectedServiceList', serviceList)
        navigate('/addClient/people')
    }

    useEffect(()=>{
        const dataFromStorage = getItemFromSessionStorage('newServiceSet')
        if(dataFromStorage){
            const newServiceArray = serviceSetFormatter(dataFromStorage)
            const newServiceArrayFilteredByType = newServiceArray.filter((service)=>{
                return service.serviceType === selectedServiceType
            })
            setOptions(newServiceArrayFilteredByType)
        }
    }, [selectedServiceType])

    useEffect(()=>{
        const selectedServiceListFromStorage = getItemFromSessionStorage('selectedServiceList')
        if(selectedServiceListFromStorage){
            setServiceList(selectedServiceListFromStorage)
        }
    }, [])

    return (
        <DataImportFormTabs flow={'addClient'}>
            <ServiceImportTemplate serviceList={serviceList} setServiceList={setServiceList} setSearchKeyword={setSearchKeyword}
                                   onNext={onNext} onSave={onSave} onPrev={onPrev} options={options} setOptions={setOptions}
                                   selectedServiceType={selectedServiceType} setSelectedServiceType={setSelectedServiceType}
                                   selectedServiceTypeId={selectedServiceTypeId} setSelectedServiceTypeId={setSelectedServiceTypeId}
                                   isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} approver={approver} setApprover={setApprover}
                                   setFormCheckSnackbar={setIsSnackbarOpen} formCheckSnackbar={isSnackbarOpen} showError={showError}
            />
            <FeedbackSnackbar setSnackbar={setSnackbar} snackbar={snackbar} />
            <LoaderBackdrop open={isLoading} loaded={loaded} />
        </DataImportFormTabs>
    )
}

export default ImportServiceForm
